import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, Row, Table } from 'antd';
import { Link } from 'react-router';
import moment from 'moment';

import { queryCustomDepartmentList } from '@api/crm/crm';
import util from '@util';
import getArea from '@comm/getArea';

const FormItem = Form.Item;
const type = ['个人', '公司'];
const related = ['未关联', '已关联'];

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      columns: [],
      total: 0,
      pageNo: 1,
    };
  }

  componentDidMount() {
    getArea(13, 1301);
    this.loadData();
  }

  handleSearch = e => {
    if (e) {
      e.preventDefault();
    }
    this.props.form.validateFields((err, values) => {
      this.condition = values.condition;
      this.loadData(1);
    });
  };

  handleFormReset = e => {
    e.preventDefault();
    this.props.form.resetFields();
    this.condition = '';
    this.loadData(1);
  };

  loadData = pageNo => {
    const no = this.state.pageNo;
    const current = pageNo || no;
    const params = {};
    params.limit = 15;
    params.start = current;
    params.condition = this.condition || '';
    this.setState({
      pageNo,
    });
    queryCustomDepartmentList(params).then(res => {
      this.setState({
        columns: res.data.columns,
        data: res.data.customs,
        total: res.totalSize,
        wid: (res.data.columns.length + 3) * 150 + 350,
      });
    });
  };

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <Form layout="inline" onSubmit={this.handleSearch}>
        <Row gutter={{ md: 8, lg: 24, xl: 48 }} style={{ minWidth: '650px' }}>
          <Col md={8} sm={24} style={{ minWidth: '400px' }}>
            <FormItem label="客户名称">
              {getFieldDecorator('condition')(
                <Input placeholder="请输入" style={{ minWidth: '200px' }} />,
              )}
            </FormItem>
          </Col>
          <Col md={8} sm={24}>
            <span className="submitButtons">
              <Button type="primary" htmlType="submit">
                查询
              </Button>
              <Button style={{ marginLeft: 8 }} onClick={this.handleFormReset}>
                重置
              </Button>
            </span>
          </Col>
        </Row>
      </Form>
    );
  };

  fieldsColumns = () => {
    const { columns } = this.state;
    return columns.map(item => {
      let params = {
        title: item.fieldName,
        dataIndex: item.field,
        width: 150,
      };
      if (item.field === 'establishedDate') {
        params = {
          ...params,
          render: text => {
            return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
          },
        };
      } else if (item.field === 'category') {
        params = {
          ...params,
          render: (text, record) => {
            return <span>{record.category1 ? `${record.category1}/${record.category2}` : ''}</span>;
          },
        };
      } else if (item.field === 'region') {
        params = {
          ...params,
          render: (text, record) => {
            return <span>{getArea(record.province, record.city)}</span>;
          },
        };
      } else if (item.field === 'related') {
        params = {
          ...params,
          render: text => {
            return <span>{related[text]}</span>;
          },
        };
      } else if (item.field === 'type') {
        params = {
          ...params,
          render: text => {
            return <span>{type[text]}</span>;
          },
        };
      }
      return params;
    });
  };

  columns = () => {
    return [
      {
        title: '客户名称',
        dataIndex: 'name',
        width: 150,
        render: (text, record) => {
          return <Link to={`/crm/custom/department/${record.uuid}/edit`}>{text}</Link>;
        },
      },
      ...this.fieldsColumns(),
      {
        title: '操作',
        dataIndex: 'done',
        width: 150,
        render: (text, record) => {
          return (
            <span>
              <Link to={`/crm/custom/department/${record.uuid}/contact`}>联系记录</Link>
            </span>
          );
        },
      },
    ];
  };

  render() {
    const { data, total, wid } = this.state;

    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: this.state.pageNo,
      onChange: current => {
        this.loadData(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <Card>
        <div className="tableList">
          <div className="tableListForm">{this.renderSearchForm()}</div>
          <div className="tableListOperator">
            <Link to="/crm/custom/department/add">
              <Button type="primary">添加</Button>
            </Link>
            <Link to="/crm/custom/department/protect">
              <Button>客户保护</Button>
            </Link>
          </div>
        </div>
        <Table
          rowKey="uuid"
          rowSelection={{}}
          columns={this.columns()}
          dataSource={data}
          pagination={pagination}
          scroll={{ x: wid, y: util.pageHeight() - 330 }}
        />
      </Card>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Index);



// WEBPACK FOOTER //
// ./src/components/crm/custom/department/Index.js